@let workout = workout$ | async;

<app-generic-view
  [backgroundImage]="
    'url(/assets/images/workout-background-img/img_' +
    workout?.sport +
    '_' +
    randomImgNumber +
    '.jpg)'
  "
  [information]="workout"
  [comments$]="comments$"
  [sameContributor$]="sameContributor$"
  (getComments)="getComments()"
  (onLikeClick)="onLikeClick($event)"
  (onEditPost)="editWorkout($event)">
  <kin-workout-player
    id="kin-workout-player"
    [informations$]="workout$"
    (onFavoriteClick)="onFavoriteClick(workout)" />
</app-generic-view>
